export interface OptionalUpgrade {
  _id: string;
  builderId: string;
  includedItems: string[];
  url: string;
  price: number;
  name: string;
}

export interface CreateOptionalUpgradeInterface {
  builderId: string;
  includedItems: string[];
  url: string;
  price: number;
  name: string;
}

export interface QueryOptionalUpgradeInterface {
  builderId?: string;
  name?: string;
  price?: number;
}

export interface UpdateOptionalUpgradeInterface {
  includedItems?: string[];
  url?: string;
  price?: number;
  name?: string;
}

export const optionalUpgradeDefault: OptionalUpgrade = {
  _id: "",
  builderId: "",
  includedItems: [],
  url: "",
  price: 0,
  name: "",
};

export interface EstateOptionalUpgrade {
  _id: string;
  name: string;
  description?: string;
  price: number;
  estateId: string;
  url?: string;
}

export type CreateEstateOptionalUpgradeInterface = Omit<
  EstateOptionalUpgrade,
  "_id"
>;
export type UpdateEstateOptionalUpgradeInterface = Partial<
  Omit<EstateOptionalUpgrade, "_id">
>;
